var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex bg-white items-center shadow-sm p-6 rounded"},[_c('p',{staticClass:"font-normal m-0 px-4 text-sm text-center",domProps:{"innerHTML":_vm._s(_vm.text)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }